import React from "react";
import { Box, Heading, Text, Image, Container, SimpleGrid, VStack, Button, useColorModeValue } from "@chakra-ui/react";

const BlogPost = ({ title, excerpt, imageSrc, date }) => {
  return (
    <VStack
      align={"flex-start"}
      bg={useColorModeValue("white", "gray.700")}
      p={5}
      borderRadius="md"
      boxShadow="md"
      spacing={3}
    >
      <Image src={imageSrc} alt={title} borderRadius="md" />
      <Text fontSize="sm" color="gray.500">
        {date}
      </Text>
      <Heading as="h3" size="md">
        {title}
      </Heading>
      <Text noOfLines={3}>{excerpt}</Text>
      <Button colorScheme="brand" variant="outline">
        Read More
      </Button>
    </VStack>
  );
};

function Blog() {
  const posts = [
    {
      title: "The Future of Solar Energy",
      excerpt: "Exploring the latest trends and innovations in solar technology...",
      imageSrc: "/path-to-blog1-image.jpg",
      date: "May 15, 2024",
    },
    {
      title: "Solar Myths Debunked",
      excerpt: "Separating fact from fiction in the world of solar energy...",
      imageSrc: "/path-to-blog2-image.jpg",
      date: "April 28, 2024",
    },
    {
      title: "Maximizing Your Solar Investment",
      excerpt: "Tips and tricks to get the most out of your solar panel system...",
      imageSrc: "/path-to-blog3-image.jpg",
      date: "April 10, 2024",
    },
  ];

  return (
    <Box py={20}>
      <Container maxW={"container.xl"}>
        <Heading as="h1" size="2xl" mb={10} textAlign="center">
          Satoal Blog
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
          {posts.map((post, index) => (
            <BlogPost key={index} {...post} />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}

export default Blog;